import taxTypeMap from 'modules/Contacts/constants/taxTypeMap';

export default function isManagement(taxCode = '', type) {
  // allowed if root tax authority was associated with users object or user
  return taxCode.endsWith('00') && type === taxTypeMap.added;
}
